import { useQuery } from '@tanstack/react-query';
import { useAiAgent } from '@/contexts/AiAgentContext';
import { intelligenceService, type UnifiedContextPack } from '@/services/intelligence.service';

export function useIntelligenceContext(opts?: { enabled?: boolean; includeSimulation?: boolean }) {
  const { pageContext } = useAiAgent();
  const hasContext = !!(pageContext.module || pageContext.docType || pageContext.docId);
  return useQuery<UnifiedContextPack>({
    queryKey: [
      'intelligence-context',
      pageContext.module,
      pageContext.docType,
      pageContext.docId,
      opts?.includeSimulation,
    ],
    queryFn: () =>
      intelligenceService.getContext({
        ...pageContext,
        includeSimulation: opts?.includeSimulation,
      }),
    enabled: (opts?.enabled ?? true) && hasContext,
    staleTime: 60_000,
    retry: 1,
  });
}
